import { ChevronRight } from "lucide-react";

import { cn } from "@/lib/utils";

type Props = { className?: string; children: string };

export function ExpanderSummary({ className, children }: Props) {
  return (
    <summary
      className={cn(
        "inline-flex cursor-pointer list-none items-center gap-1 rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 [&::-webkit-details-marker]:hidden",
        className,
      )}
    >
      <ChevronRight
        aria-hidden
        className="h-3.5 w-3.5 group-open:rotate-90 motion-safe:transition-transform motion-safe:duration-150 motion-safe:ease-[cubic-bezier(.23,1,.32,1)]"
      />
      {children}
    </summary>
  );
}
